import axios from "axios";
import { get } from "lodash";
import { error, log } from "../../utils/logger";
import {
  MOBILE_ORIGINATED_LOADING,
  SET_MO_COUNTS,
  RESET_REPORTS,
  ADD_REPORT_ERROR,
} from "../constants";

export const MO_SESSION_TOKEN = "amrnMobileOriginatedOptions";

export const addError = (error, name) => (dispatch) => {
  dispatch({ type: ADD_REPORT_ERROR, payload: error, name });
};

// ============================================================================
// Get Data ===================================================================
// ============================================================================

export const getMobileOriginatedCounts = (options) => (dispatch) => {
  log(`Getting mobile originated counts with options`, options);

  dispatch({ type: MOBILE_ORIGINATED_LOADING, payload: "counts" });

  return axios
    .post(`reports/mobile-originated/counts`, options)
    .then((res) => {
      const payload = get(res, "data.counts");

      payload && dispatch({ type: SET_MO_COUNTS, payload });

      return payload;
    })
    .catch((err) => {
      error("Error getting mobile originated counts", err);
      dispatch(addError(err, "counts"));
    });
};

//reset landing reducer state
export const resetState = () => ({ type: RESET_REPORTS });
